// extracted by mini-css-extract-plugin
export default {"scroll-to-top":"scroll-to-top--HoTxV","scroll-to-top__icon":"scroll-to-top__icon--YYGCS"};